import { useMemo } from "react"

export const useCoveredMedicines = (medicines: any[], coveredMonths: number = 1) => {
    return useMemo(() => {

        return medicines.map((item) => {
            const multiplier = item.isCustomAmount ? 1 : coveredMonths;

            if (item.altMedicine?.value && !item.isDefault) {
                return {
                    ...item,
                    directAmount: (item.directAmount || 0) * multiplier,
                    altPrice: (item.altPrice || 0) * multiplier,
                };
            }

            return {
                ...item,
                amount: (item.amount || 0) * coveredMonths,
                price: (item.price || 0) * coveredMonths,
            }
        })
    }, [medicines, coveredMonths])
}